export default "__VITE_ASSET__CGU3$nJW__"